import { TourState } from 'editor/src/store/editorModules/tour/types';
import { RootState } from 'editor/src/store/index';

const getIntroTourSteps = (state: RootState): TourState['introSteps'] => {
  return state.editorModules.tour.introSteps;
};

export default getIntroTourSteps;
